import {
  ADD_BRANCH_MANAGER,
  GET_BRANCH_MANAGER,
  EDIT_BRANCH_MANAGER,
  DELETE_BRANCH_MANAGER,
  BLOCK_BRANCH_MANAGER,
} from "../constants/action-types";

const initilState = {
  state: "",
};

const branchManagerReducer = (state = initilState, action) => {
  switch (action.type) {
    case ADD_BRANCH_MANAGER:
      return {
        ...state,
        ...state.data.push(action?.payload),
      };
    case GET_BRANCH_MANAGER:
      return {
        ...state,
        data: action.payload,
      };
    case EDIT_BRANCH_MANAGER:
      const index = state.data.findIndex(
        (ele) => ele.id === action?.payload.id
      );
      state.data.splice(index, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };
    case DELETE_BRANCH_MANAGER:
      const deleteIndex = state.data.filter(
        (ele) => ele.id !== action?.payload.id
      );
      return {
        ...state,
        data: deleteIndex,
      };
    case BLOCK_BRANCH_MANAGER:
      const blockIndex = state.data.findIndex(
        (ele) => ele.id === action?.payload.id
      );
      state.data.splice(blockIndex, 1, action?.payload);
      return {
        ...state,
        ...state.data,
      };
    default:
      return state;
  }
};

export default branchManagerReducer;
